import {Component} from '@angular/core'
import {SystemUpdateService} from '../../services/system-update.service'

@Component({
  selector: 'app-system-updates-list',
  templateUrl: './system-updates-list.component.html',
  styleUrls: ['./system-updates-list.component.css'],
  standalone: false
})
export class SystemUpdatesListComponent {
  constructor(public systemUpdate: SystemUpdateService) {
  }
}
